<section [ngClass]="dynamicClass" [attr.id]="dynamicId ? dynamicId : null" class="pb-container pb-space-y-6">
    <div class="pb-space-y-4">
        <h2 class="pb-text-color-brand pb-font-serif pb-text-d-xl-m md:pb-text-d-xl lg:pb-w-2/3" data-title="true" *scText="rendering?.fields?.Title"></h2>
        <h3 class="pb-text-md-m md:pb-text-md lg:pb-w-2/3" *scText="rendering?.fields?.Subtitle"></h3>
    </div>
    <div id="Map" class="pb-map pb-relative pb--animate pb-FadeUp">
        <div>
            <div *ngIf="isVisible" class="pb-c-InfoWindow-Yellow lg:pb-m-4 pb-h-fit md:pb-max-w-[400px] sm:pb-min-w-[400px] pb-flex pb-flex-col pb-absolute pb-inset-0 pb-z-[5] md:pb-inset-auto md:pb-right-0">
                <div class="pb-top-window pb-flex pb-flex-col pb-gap-2 pb-relative !pb-p-5">
                    <div class="pb-flex pb-flex-row pb-gap-5 pb-w-full pb-justify-between pb-items-center">
                        <ng-container *ngIf="partner; else BranchName">
                            <h3 class="pb-text-md-m md:pb-text-md">{{ partner }}</h3>
                        </ng-container>
                        <ng-template #BranchName>
                            <h3 class="pb-text-md-m md:pb-text-md">{{ infoWindoData?.Merchant }}</h3>
                        </ng-template>
                        
                        <button (click)="onClosePopup(false)">
                            <i class="pb-icon pb-text-i-32 pb-icon-close"></i>
                        </button>
                    </div>
                    <h2 *ngIf="infoWindoData?.BranchName" class="pb-text-h-sm-m md:pb-text-h-sm pb-font-bold">{{ infoWindoData?.BranchName }}</h2>
                    <h4 class="pb-text-md-m md:pb-text-md">{{ infoWindoData?.Address }} {{ infoWindoData?.AddressNumber }}, {{ infoWindoData?.City }} {{ infoWindoData?.ZipCode }}, {{ infoWindoData?.Prefecture }}</h4>
                </div>
            </div>
        </div>
        <div *ngIf="!this._isPlatformServer" id="map" class="pb-w-full pb-h-[750px]"></div>
    </div>
</section>
